import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = ["template"]

  add(event) {
    event.preventDefault()
    if (!this.hasTemplateTarget) return

    const index = Date.now()
    const clone = this.templateTarget.cloneNode(true)
    clone.removeAttribute("data-nested-fields-v3-target")
    clone.classList.remove("d-none")
    clone.classList.add("nested-fields-v3-item")
    clone.dataset.persisted = "false"

    clone.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = false
      ;["name", "id"].forEach((attr) => {
        const value = field.getAttribute(attr)
        if (value) field.setAttribute(attr, value.replace(/\d+/, index))
      })
    })
    clone.querySelectorAll("label[for]").forEach((label) => {
      const value = label.getAttribute("for")
      if (value) label.setAttribute("for", value.replace(/\d+/, index))
    })

    this.templateTarget.before(clone)
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest(".nested-fields-v3-item")
    if (!row) return

    const destroyField = row.querySelector("input[name$='[_destroy]']")

    if (row.dataset.persisted === "true" && destroyField) {
      destroyField.value = "1"
      row.classList.add("d-none")
    } else {
      row.remove()
    }
  }
}
